import React from 'react'

const CoreComponent20 = ({content}) => {
  return (
   <div className="row  d-flex justify-content-center">
      {content.map((val, i) => (
        <div
          className="col-lg-4 col-md-6   mb-4 "
          style={{ width: "", height:'' }}
          key={i}
        >
          <div className='p-4 h-100   bg-white  rounded-4 border'>

          <img className="mx-0  icon-logo" src={val.icon} alt="" />
          <h3 className="h3-heading lh-base text-start my-lg-3 mt-2 mb-1"> {val.title}</h3>
          <p className='h3-para lh-base'>{val.desc}</p>
          </div>
        </div>
      ))}
    </div>
  )
}

export default CoreComponent20